/**
 * Licensed commercial banks in Tanzania (Bank of Tanzania register).
 * Source: https://www.bot.go.tz/BankSupervision/Institutions
 */
const BANK_NAMES = [
  'Absa Bank Tanzania Limited',
  'Access Bank Tanzania Ltd',
  'Akiba Commercial Bank PLC',
  'Amana Bank Limited',
  'Azania Bank Public Limited Company',
  'Bank of Africa Tanzania Limited',
  'Bank of Baroda Tanzania Limited',
  'Bank of India Tanzania Limited',
  'Canara Bank Tanzania Limited',
  'China Dasheng Bank Limited',
  'Citibank Tanzania Limited',
  'CRDB Bank PLC',
  'DCB Commercial Bank PLC',
  'Diamond Trust Bank Tanzania PLC',
  'Ecobank Tanzania Limited',
  'Equity Bank Tanzania Limited',
  'Exim Bank Tanzania Limited',
  'Guaranty Trust Bank Tanzania Limited',
  'Habib African Bank (Africa and Gulf Bank Tanzania) Limited',
  'International Commercial Bank Tanzania Ltd',
  'I & M Bank Tanzania Limited',
  'KCB Bank Tanzania Limited',
  'Letshego Faidika Bank Tanzania Limited',
  'Maendeleo Bank PLC',
  'Mkombozi Commercial Bank PLC',
  'Mwalimu Commercial Bank PLC',
  'Mwanga Hakika Bank Ltd',
  'National Bank of Commerce Limited',
  'NCBA Bank Tanzania Limited',
  'NMB Bank PLC',
  "People's Bank of Zanzibar Limited",
  'Stanbic Bank Tanzania Ltd',
  'Standard Chartered Bank Tanzania Ltd',
  'Tanzania Commercial Bank PLC',
  'United Bank for Africa Tanzania Limited',
];

export const TANZANIA_BANK_OPTIONS = BANK_NAMES.map((name) => ({
  value: name,
  label: name,
}));

export const getBankLabel = (value) => value || '';

/** Include a saved custom bank name if it is not already in the list. */
export const getBankOptions = (savedBankName = '') => {
  if (!savedBankName?.trim()) return TANZANIA_BANK_OPTIONS;

  const normalized = savedBankName.trim();
  const exists = TANZANIA_BANK_OPTIONS.some((option) => option.value === normalized);

  if (exists) return TANZANIA_BANK_OPTIONS;

  return [{ value: normalized, label: normalized }, ...TANZANIA_BANK_OPTIONS];
};
